module.exports = __webpack_public_path__ + "r-v3/img/ml_61_00.149947b2.jpg";